import * as React from "react";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { TransactionSummarryCollection } from "../../../../../../../../Wrap/Models/Domains/Transactions/Summary/TransactionSummarryCollection";
import AriaTooltip from "../../../../../../../Shared/Tooltip/AriaTooltip";
import { ChargesTable } from "./Components/ChargesTable";
import { PaymentsInTable } from "./Components/PaymentsInsTable";
import { SummaryTable } from "./Components/SummaryTables";
import { WithdrawalsTable } from "./Components/WithdrawalsTable";
import { chargesToolTipText } from "./Resources/Content";

interface ITransactionsSummaryProps {
    data: TransactionSummarryCollection;
    from?: Date;
    to?: Date;
    onTableChange: () => void;
}

export const TransactionsSummary = (props: ITransactionsSummaryProps) => {
    const fromDateStr = props.from == null ? "" : JsonDateParser.getFormatDateString(props.from, "dd MM yyyy", true);
    const toDateStr = props.to == null ? "" : JsonDateParser.getFormatDateString(props.to, "dd MM yyyy", true);
    return (
        <div className="pt-16">
            <h2 className="mb-8">
                Summary from {fromDateStr} until {toDateStr}
            </h2>
            <p>This shows a summary of money paid in and/or paid out of your portfolio.</p>
            <SummaryTable data={props.data != null ? props.data.TransactionSummaries : null} />
            <h2 className="pt-18">Money in</h2>
            <PaymentsInTable data={props.data != null ? props.data.MoneyInTransactionSummaries : null} />
            <h2 className="pt-18">Withdrawals</h2>
            <WithdrawalsTable data={props.data != null ? props.data.WithdrawalsTransactionSummaries : null} />
            <h2 className="pt-18">
                Charges
                <AriaTooltip cssWrapper="is-info-icon ml-5" showCloseButton={true} title="More on charges">
                    {chargesToolTipText.chargesHeadingToolTip}
                </AriaTooltip>
            </h2>
            <ChargesTable data={props.data != null ? props.data.ChargesTransactionSummaries : null} />
        </div>
    );
};
